import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[textEllipsisToTooltip]',
  standalone: false,
})
export class TextEllipsisToTooltipDirective implements AfterViewInit {
  public htmlEl: HTMLElement;
  constructor(
    private el: ElementRef,
    private tooltip: NgbTooltip
  ) {
    this.htmlEl = this.el.nativeElement;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.htmlEl.offsetWidth < this.htmlEl.scrollWidth) {
        this.htmlEl.classList.add('cursor-pointer');
        if (!this.tooltip.ngbTooltip) {
          this.tooltip.ngbTooltip = this.htmlEl.innerHTML;
        }
      } else {
        this.tooltip.ngbTooltip = '';
      }
    }, 0);
  }
}
